<template>
  <transition :name="'imbee-' + animation">
    <div
      class="imbee-bubble-text-badge"
      :style="{ backgroundColor }"
      v-if="show && !opened && !showCta"
    >
      <span
        :style="{
          fontWeight,
          fontSize,
          fontFamily,
          color,
        }"
        >{{ text }}</span
      >
    </div>
  </transition>
</template>

<script>
export default {
  name: "TextBadge",
  props: {
    show: { type: Boolean, default: false },
    opened: { type: Boolean, default: false },
    animation: { type: String, default: "fade" },
    text: { type: String, default: "" },
    color: { type: String, default: "" },
    backgroundColor: { type: String, default: "" },
    fontSize: { type: String, default: "" },
    fontWeight: { type: String, default: "" },
    fontFamily: { type: String, default: "" },
    showCta: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.imbee-bubble-text-badge {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  display: -webkit-box; 
  display: -moz-box; 
  display: -ms-flexbox; 
  display: -webkit-flex; 
  display: flex; 
  padding: 3px 8px;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-size: 10px;
  font-weight: bold;
  font-family: "Arial";
  line-height: 1.2;
  background-color: #ed317e;
  top: -23px;
  width: auto;
  position: absolute;
  border-radius: 20px;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  -ms-border-radius: 20px;
  -o-border-radius: 20px;
  white-space: nowrap;
}
</style>


// WEBPACK FOOTER //
// TextBadge.vue?0f7faa08